import React from "react";
import { useTranslation } from "react-i18next";
import { Label, Modal, ModalBody } from "reactstrap";
import { LogsDto } from "../../interfaces";
import StackTraceViewer from "./StackTraceViewer";

type TProps = {
  log: LogsDto | null | undefined;
  onCloseClick: (event: any) => void;
  show: boolean;
};

function formatJson(value: Record<string, unknown> | null | undefined): string {
  if (!value || Object.keys(value).length === 0) {
    return "-";
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return "-";
  }
}

const LogDetailModal: React.FC<TProps> = ({ log, show, onCloseClick }) => {
  const { t } = useTranslation();
  return (
    <Modal size="lg" isOpen={show} toggle={onCloseClick} centered={true}>
      {log && (
        <ModalBody className="">
          <div className="mt-2">
            <h4
              className={
                log.level === "error"
                  ? "text-danger"
                  : log.level === "warn"
                  ? "text-warning"
                  : log.level === "info"
                  ? "text-success"
                  : ""
              }
            >
              {t(log.level)}
            </h4>
            <p>
              {new Date(log.timestamp).toLocaleDateString()}{" "}
              {new Date(log.timestamp).toLocaleTimeString()}
            </p>
            <Label className="fw-bold">{t("serviceName")}</Label>
            <p>{log.serviceName || "-"}</p>
            <Label className="fw-bold">{t("environment")}</Label>
            <p>{log.environment || "-"}</p>
            <Label className="fw-bold">{t("host")}</Label>
            <p>{log.host || "-"}</p>
            <Label className="fw-bold">{t("message")}</Label>
            <p>{log.message || "-"}</p>
            <StackTraceViewer stack={log.stack} />
            <Label className="fw-bold">{t("statusCode")}</Label>
            <p>{log.statusCode || "-"}</p>
            <Label className="fw-bold">{t("method")}</Label>
            <p>{log.method || "-"}</p>
            <Label className="fw-bold">{t("path")}</Label>
            <p>{log.path || "-"}</p>
            <Label className="fw-bold">{t("userAgent")}</Label>
            <p>{log.userAgent || "-"}</p>
            <Label className="fw-bold">{t("ip")}</Label>
            <p>{log.ip || "-"}</p>
            <Label className="fw-bold">{t("errorName")}</Label>
            <p>{log.errorName || "-"}</p>
            <Label className="fw-bold">{t("errorCode")}</Label>
            <p>{log.errorCode || "-"}</p>
            <Label className="fw-bold">{t("userId")}</Label>
            <p>{log.userId || "-"}</p>
            <Label className="fw-bold">{t("metadata")}</Label>
            <pre className="bg-light p-2 rounded small">
              {formatJson(log.metadata)}
            </pre>
            <Label className="fw-bold">{t("headers")}</Label>
            <pre className="bg-light p-2 rounded small">
              {formatJson(log.headers)}
            </pre>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              data-bs-dismiss="modal"
              onClick={onCloseClick}
            >
              {t("close")}
            </button>
          </div>
        </ModalBody>
      )}
    </Modal>
  );
};

export default LogDetailModal;
